
export const provinceList = [
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/11.html",
      "name": "北京市",
      "code": "11"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/12.html",
      "name": "天津市",
      "code": "12"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/13.html",
      "name": "河北省",
      "code": "13"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/14.html",
      "name": "山西省",
      "code": "14"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/15.html",
      "name": "内蒙古自治区",
      "code": "15"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/21.html",
      "name": "辽宁省",
      "code": "21"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/22.html",
      "name": "吉林省",
      "code": "22"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/23.html",
      "name": "黑龙江省",
      "code": "23"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/31.html",
      "name": "上海市",
      "code": "31"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/32.html",
      "name": "江苏省",
      "code": "32"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/33.html",
      "name": "浙江省",
      "code": "33"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/34.html",
      "name": "安徽省",
      "code": "34"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/35.html",
      "name": "福建省",
      "code": "35"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/36.html",
      "name": "江西省",
      "code": "36"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/37.html",
      "name": "山东省",
      "code": "37"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/41.html",
      "name": "河南省",
      "code": "41"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/42.html",
      "name": "湖北省",
      "code": "42"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/43.html",
      "name": "湖南省",
      "code": "43"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/44.html",
      "name": "广东省",
      "code": "44"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/45.html",
      "name": "广西壮族自治区",
      "code": "45"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/46.html",
      "name": "海南省",
      "code": "46"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/50.html",
      "name": "重庆市",
      "code": "50"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/51.html",
      "name": "四川省",
      "code": "51"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/52.html",
      "name": "贵州省",
      "code": "52"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/53.html",
      "name": "云南省",
      "code": "53"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/54.html",
      "name": "西藏自治区",
      "code": "54"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/61.html",
      "name": "陕西省",
      "code": "61"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/62.html",
      "name": "甘肃省",
      "code": "62"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/63.html",
      "name": "青海省",
      "code": "63"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/64.html",
      "name": "宁夏回族自治区",
      "code": "64"
    },
    {
      "url": "https://www.stats.gov.cn/sj/tjbz/tjyqhdmhcxhfdm/2023/65.html",
      "name": "新疆维吾尔自治区",
      "code": "65"
    }
  ]



// WEBPACK FOOTER //
// ./src/assets/ChinaArea/province.js